import { render } from "./gamesFundSection.vue?vue&type=template&id=07a21905"
import script from "./gamesFundSection.vue?vue&type=script&lang=js"
export * from "./gamesFundSection.vue?vue&type=script&lang=js"

import "./gamesFundSection.vue?vue&type=style&index=0&id=07a21905&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__